var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-app"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/logo/app_logo.png")}}),_vm._m(0),_c('div',{staticClass:"open",on:{"click":_vm.gotoApp}},[_vm._v("Download")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-info"},[_c('div',{staticClass:"app-name"},[_vm._v("OMNI")]),_c('div',{staticClass:"app-desc"},[_vm._v("Open in the OMNI app")])])
}]

export { render, staticRenderFns }